import { render, staticRenderFns } from "./DialogConfig.vue?vue&type=template&id=cd3441a8"
import script from "./DialogConfig.vue?vue&type=script&lang=js"
export * from "./DialogConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports